<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <header>
        <div>
          <div>
            <b-navbar toggleable="lg" type="light" variant="info">
            <b-navbar-brand @click="navClick('/')" class="m-logo">
              <!-- <img src="@/assets/images/logo.svg" class="img-fluid"> -->
              <b-img src="@/assets/images/logo-white.png" fluid class="img-fluid" alt="Responsive image"></b-img>
            </b-navbar-brand>
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav align="right" align-items-center>
                <b-nav-item  @click="navClick('/day-care-service')">Day Care Services</b-nav-item>
                <b-nav-item  @click="navClick('/home-care-service')">Home Care Services</b-nav-item>
                <b-nav-item  @click="navClick('/our-activities')">Our Activities</b-nav-item>
                <b-nav-item  @click="navClick('/about-us')">About Us</b-nav-item>
                <b-nav-item @click="navClick('/careers')">Careers</b-nav-item>
                <b-nav-item  @click="navClick('/contactus')">Contact</b-nav-item>
                <b-nav-item  v-b-modal.my-modal>
                  <b-button variant="primary" class="btn_normal btn_contact d-flex flex-column align-items-center" href="#">Free Consultation</b-button>
                </b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
          </div>
        </div>
    </header>

    <!--===Header Area End===-->
  </div>
  
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
    };
  },
  methods: {
    navClick(href) {
      this.$router.replace({
        path: href
      }).catch(()=>{})
    }
  }
};
</script>
<style lang="scss" scoped>
// @import '../assets/scss/common';
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
  border-bottom: 1px solid #C0C0C0;
}

header {
    background: $w-color;
}

.navbar {
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  max-width: 100%;
  padding: 10px 30px;
  align-items: center;
  background-color: $w-color!important;
  .navbar-brand {
    color: $primary-font;
  }
  .nav-link {
    color: $primary-font;
  }
  .navbar-collapse {
    flex-grow: 0;
  }
}

.navbar-nav {
  align-items: center;
  .nav-item a:hover {
    color: $primary-font;
    opacity: 0.6;
  }
}

.nav-item {
  font-size: 1.6rem;
  margin-left: 30px;
}

.m-logo {
  font-size: 20px;
  line-height: 1;
  .img-fluid {
      height: 10rem;
  }
}

.ic-navbar {
    padding: 0px;
}

.ic-navbar-nav {
    position: relative;
    li {
        padding: 0px 2px;
        &:first-child a {
            padding-left: 0px;
        }
        &:hover a {
            background: $p-color;
        }
        a {
            font-family: 'Playfair Display', serif;
            color: #ffffff;
            text-transform: capitalize;
            font-size: 16px;
            padding: 30px 18px !important;
            @include transition(0.3s);
            &.active {
                background: $p-color;
            }
        }
    }
}

.ic-dropdown-item {
    position: relative;
    .ic-dropdown-menu {
        li {
            a {
                padding: 8px 12px !important;
                display: block;
                color: #303030;
            }
        }
    }
    &:hover {
        .ic-dropdown-menu a {
            background: none;
        }
    }
    .ic-dropdown {
        position: relative;
        padding-right: 36px!important;
        &:after {
            content: "\eac8";
            font-family: IcoFont !important;
            font-weight: 700;
            display: unset;
            vertical-align: 0;
            border-top: none;
            border: none;
            position: absolute;
            right: 16px;
            margin-top: 2px;
            font-size: 15px;
            margin-left: 0px;
        }
    }
}

@media(min-width: 768.98px) {
    .ic-section {
      flex-wrap: wrap;
    }
}

.ic-navbar-search-icon {
    a {
        color: #fff;
        i {
            font-size: 20px;
        }
    }
}

.ic-menu-search-warper {
    position: relative;
}

.ic-search-close {
    display: none;
}

.ic-nav-search-box {
    position: absolute;
    top: 80px;
    width: 300px;
    z-index: 99;
    right: 0;
    background: #fff;
    @include box-shadow(0px, 4px, 14.72px, 1.28px, 48, 48, 48, 0.05);
    padding: 20px;
    @include transition(0.5s);
    opacity: 0;
    visibility: hidden;
    &.active {
        opacity: 1;
        visibility: visible;
        top: 55px;
    }
    .ic-search-area {
        .form-group {
            position: relative;
        }
        .form-control {
            @include bd-radius(0px);
            width: 100%;
            &:focus {
                outline: none;
                box-shadow: none;
            }
        }
        button {
            background: #00539c;
            border: 1px solid #00539c;
            border-radius: 0px;
            padding: .375rem .75rem;
            color: #fff;
            position: absolute;
            top: 0;
            right: 0;
        }
    }
}

.btn_contact {
      font-weight: 700;
      color: $w-color;
      background-color: $btn-background;
      padding: 0.8rem 1.6rem;
      transition: 0.2s ease-in;
      box-shadow: 4px 4px 4px #0000001a;
      border-radius: 0;
      border: 0;
      justify-content: center;
    }

.navbar-toggler {
  span.navbar-toggler-icon {
    background-color: $s-color;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue